import axios from "axios";
import routes from "../../configs/api";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";

const getAllPartner = ({
  search = "",
  sortField = "createdAt",
  sortOrder = "desc",
  startDate = "",
  endDate = "",
  page = 1,
  limit = 10,
  includeChart = false,
}) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);

  return new Promise((resolve, reject) => {
    const params = new URLSearchParams({
      search,
      sortField,
      sortOrder,
      page: String(page),
      limit: String(limit),
      includeChart: String(includeChart),
    });

    if (startDate && endDate) {
      params.set("startDate", startDate);
      params.set("endDate", endDate);
    }

    const URL = `${routes.GET_ALL_PARTNER}?${params.toString()}`;
    axios
      .get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export { getAllPartner };
